import { render, staticRenderFns } from "./LockerPickupPointInfos.vue?vue&type=template&id=6c2f715b"
import script from "./LockerPickupPointInfos.vue?vue&type=script&lang=ts"
export * from "./LockerPickupPointInfos.vue?vue&type=script&lang=ts"
import style0 from "./LockerPickupPointInfos.vue?vue&type=style&index=0&id=6c2f715b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports